import { post, get } from '.';

export const sendRequestAccess = () => post(`/dmc-request-access`);
export const getDmcRequestAccess = () => get(`/dmc-request-access`);
